import { EProfileElementStatus } from '../types';

export const HIDE_PROFILE_ELEMENT = [
  EProfileElementStatus.Disabled,
  EProfileElementStatus.Readonly,
  EProfileElementStatus.Readonly,
];
